// JOBE-0106 follow-up: SettingsGlanceBlock — side-rail block #3.
//
// Small read-only glance card: status + department URN chip +
// "created N days ago" derived from the entity envelope. Click →
// `?tab=settings` (the full Settings sub-tab is the long-form read).

import React from 'react';

function urnTail(urn) {
  if (!urn || typeof urn !== 'string') return '';
  return urn.split(':').pop() || urn;
}

function pickCreatedAt(detail) {
  if (!detail) return null;
  // Wire shape carries the envelope on the embedded clientEntity
  // (`envelope.createdAt`); flat-shape test fixtures expose
  // `createdAt` at the top level. Both pickups are honored.
  return (
    detail?.envelope?.createdAt
    || detail?.envelope?.created_at
    || detail?.createdAt
    || null
  );
}

export function daysAgoLabel(iso, now = new Date()) {
  if (!iso) return null;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  const diffMs = now.getTime() - t;
  const day = 24 * 60 * 60 * 1000;
  const days = Math.max(0, Math.floor(diffMs / day));
  if (days === 0) return 'created today';
  if (days === 1) return 'created 1 day ago';
  return `created ${days} days ago`;
}

export function SettingsGlanceBlock({ detail, onOpenSettings }) {
  const status = detail?.status || detail?.payload?.status || detail?.fields?.status || null;
  const department =
    (detail?.relations?.inDepartment && detail.relations.inDepartment[0]) || null;
  const created = daysAgoLabel(pickCreatedAt(detail));

  const handleClick = (e) => {
    if (typeof onOpenSettings === 'function') {
      e.preventDefault();
      onOpenSettings();
    }
    // When no handler is wired, the anchor's `href` carries the URL
    // intent (`?tab=settings`) and the browser handles the navigation.
  };

  return (
    <section
      className="project-home-rail-block project-home-rail-settings card"
      data-testid="rail-settings-glance"
      aria-label="Settings at a glance"
    >
      <header className="project-home-rail-block-header">
        <h3 className="project-home-rail-block-title">Settings</h3>
        <a
          href="?tab=settings"
          className="project-home-rail-settings-link"
          data-testid="rail-settings-open"
          onClick={handleClick}
        >
          open →
        </a>
      </header>
      <dl className="project-home-rail-settings-list">
        <dt>Status</dt>
        <dd data-testid="rail-settings-status">
          {status ? <span className="badge">{status}</span> : <span className="muted">—</span>}
        </dd>
        <dt>Department</dt>
        <dd data-testid="rail-settings-dept">
          {department ? (
            <span className="mono project-home-rail-dept-chip">{urnTail(department)}</span>
          ) : (
            <span className="muted">—</span>
          )}
        </dd>
        <dt>Created</dt>
        <dd className="muted" data-testid="rail-settings-created">
          {created || '—'}
        </dd>
      </dl>
    </section>
  );
}
